import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../layouts";

function PrivateRoutes() {
    const navigate = useNavigate();
    const [data, setData] = useState()

    useEffect(() => {
        try {
            const userData = localStorage.getItem("token");
            setData(userData);
            // if (!userData)navigate("/login");
        }
        catch (error) {
            console.log('Private Route Error ::: ', error);
        }
    }, [data]);

    return (
        <>
            <Layout />
        </>
    );
}

export default PrivateRoutes;